export default "__VITE_ASSET__BQGcoGBl__"